import { Select, SelectChangeEvent, MenuItem } from '@mui/material'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { ModalAdSheduleAddStore } from 'src/stores/ModalStore';

const menuProps = {
    PaperProps: {
        sx: {
          // maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
        paddingTop: 0,
        paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}

const sx = {
    height:'46px',
    minWidth: '102px',
    textAlign:'center',
    justifyContent:'center',
    border: '1.5px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
}

const DropBoxSx = {
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

const ModalSelectType = () => {
    const typeContent = ['부사관','장교','준사관']
    // const [type,setType] = useState('부사관');
    const setField = ModalAdSheduleAddStore((state)=>state.setField)
    const type = ModalAdSheduleAddStore((state)=>state.type)
    const handleTypeChange = (e:SelectChangeEvent<string>)=>{
        // setType(e.target.value)
        setField('type',e.target.value)
    }
  return (
      <Select
          displayEmpty
          value={type}
          onChange={handleTypeChange}
          renderValue={(selected) => `${selected}` || '부사관' }
          MenuProps={menuProps}
          sx={sx}
          IconComponent={KeyboardArrowDown}
          >
          {typeContent.map((content, index) => (
              <MenuItem value={content.toString()} sx={DropBoxSx} key={index}>
                  {content}
              </MenuItem>
          ))}
      </Select>
  )
}

export default ModalSelectType